import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetOrganizationWithoutStructure } from '../../store/HR/Organizations/OrganizationStructureSice';
import { useTranslation } from 'react-i18next';

const useGetOrganizationWithoutStructure = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const {
    OrganizationListWithoutStructure,
    loading2: loading,
    error2: error
  } = useSelector(state => state.OrganizationStructure);
  useEffect(() => {
    // if (OrganizationListWithoutStructure?.length === 0) {
    dispatch(GetOrganizationWithoutStructure());
    // }
  }, []);

   

  return {
    OrganizationListWithoutStructure,
    loading,
    error
  };
};

export default useGetOrganizationWithoutStructure;
